function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-collateral-genrator",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "show",
  transform: "translate(-1.000000, 0.000000)",
  fill: "#41ABC1"
}, React.createElement("g", {
  id: "Group-3"
}, React.createElement("path", {
  d: "M1,8.49997659 C1,13.1754519 4.90194318,17 9.66297727,17 L32.3370227,17 C37.1016761,17 41,13.1749836 41,8.49997659 C41,3.82498907 37.1016761,0 32.3370227,0 L9.66297727,0 C4.90194318,0 1,3.82452078 1,8.49997659 Z",
  id: "Shape",
  fillOpacity: 0.2
}), React.createElement("path", {
  d: "M32.4938449,3.17391304 C35.5187692,3.17391304 38,5.63878711 38,8.66774811 C38,11.6934644 35.5195951,14.173913 32.4938449,14.173913 C29.4648303,14.173913 27,11.6926778 27,8.66774811 C27,5.6395737 29.4656563,3.17391304 32.4938449,3.17391304 Z",
  id: "Path"
}), React.createElement("text", {
  id: "Show",
  fontFamily: "MavenPro-Regular, Maven Pro",
  fontSize: 7,
  fontWeight: "normal"
}, React.createElement("tspan", {
  x: 4.672,
  y: 11
}, "SHOW")))));

var SvgShow = function SvgShow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "40px",
    height: "17px",
    viewBox: "0 0 40 17",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/show.c7ae083c.svg";
export { ForwardRef as ReactComponent };